import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'editButton', 'actions', 'form']

  edit () {
    this.inputTargets.forEach((input) => {
      input.readOnly = false
    })
    this.editButtonTarget.classList.add('hidden')
    this.actionsTarget.classList.remove('hidden')
    this.inputTargets[0]?.focus()
  }

  cancel () {
    this.formTarget.reset()
    this.inputTargets.forEach((input) => {
      input.readOnly = true
    })
    this.editButtonTarget.classList.remove('hidden')
    this.actionsTarget.classList.add('hidden')
  }
}
